import { ReactComponent as Moisture } from '../assets/scalp/icon_scalp_moisture_l_gray.svg';
import { ReactComponent as Temperature } from '../assets/scalp/icon_scalp_temperature_l_gray.svg';
import { ReactComponent as Smell } from '../assets/scalp/icon_scalp_smell_l_gray.svg';
import { ReactComponent as Keratin } from '../assets/scalp/icon_scalp_keratin_l_gray.svg';
import { ReactComponent as Sensitivity } from '../assets/scalp/icon_scalp_sensitivity_l_gray.svg';
import { ReactComponent as Fraction } from '../assets/scalp/icon_scalp_fraction_l_gray.svg';
import { ReactComponent as Volume } from '../assets/scalp/icon_scalp_hairvolume_l_gray.svg';
import { ReactComponent as Density } from '../assets/scalp/icon_scalp_density_l_gray.svg';
import { ReactComponent as Follicle } from '../assets/scalp/icon_scalp_hair_l_gray.svg';

const goodColor = '#6435c7';
const normalColor = '#ffa600';
const badColor = '#e70000';
// scalp_position_enum
export const ALL = 'ALL';
export const FOREHEAD = 'FOREHEAD';
export const CROWN = 'CROWN';
export const HIND_HEAD = 'HIND_HEAD';
export const SIDE_HEAD = 'SIDE_HEAD';

export const scalpResultOrder = {
  GENERAL: 0,
  WATER: 1,
  GAS: 2,
  TEMPERATURE: 3,
  AMBIENT_MOISTURE: -1,
  AMBIENT_GAS: -2,
  AMBIENT_TEMP: -3,
  DEAD_SKIN: 4,
  SENSITIVITY: 5,
  OIL: 6,
  HAIR_THICKNESS: 7,
  HAIR_QUANTITY: 8,
  HAIR_FOLLICLE_DENSITY: 9,
  HAIR_PER_HAIR_FOLLICLE: 10,
};

export const SCALP_HEALTH_SCORE = 'SCALP_HEALTH_SCORE';
export const SENSITIVITY = 'SENSITIVITY';
export const DEAD_SKIN = 'DEAD_SKIN';
export const OIL = 'OIL';
export const HAIR_FOLLICLE_DENSITY = 'HAIR_FOLLICLE_DENSITY';
export const HAIR_THICKNESS = 'HAIR_THICKNESS';
export const HAIR_QUANTITY = 'HAIR_QUANTITY';
export const TEMPERATURE = 'TEMPERATURE';
export const WATER = 'WATER';
export const HAIR_PER_HAIR_FOLLICLE = 'HAIR_PER_HAIR_FOLLICLE';

export const getDiagnosisItemTypeValue = (diagnosisItemType) => {
  let MIN_AND_MAX;
  switch (diagnosisItemType) {
    case SCALP_HEALTH_SCORE:
      MIN_AND_MAX = {
        min: 0,
        max: 100,
      };
      break;
    case HAIR_PER_HAIR_FOLLICLE:
      MIN_AND_MAX = {
        min: 0,
        max: 4,
      };
      break;
    case SENSITIVITY:
      MIN_AND_MAX = {
        min: 0,
        max: 50,
      };
      break;
    case WATER:
      MIN_AND_MAX = {
        min: 0,
        max: 120,
      };
      break;
    case DEAD_SKIN:
      MIN_AND_MAX = {
        min: 0,
        max: 20,
      };
      break;
    case TEMPERATURE:
      MIN_AND_MAX = {
        min: 20,
        max: 40,
      };
      break;
    case OIL:
      MIN_AND_MAX = {
        min: 0,
        max: 50,
      };
      break;
    case HAIR_FOLLICLE_DENSITY:
      MIN_AND_MAX = {
        min: 5,
        max: 40,
      };
      break;
    case HAIR_THICKNESS:
      MIN_AND_MAX = {
        min: 0,
        max: 0.5,
      };
      break;
    case HAIR_QUANTITY:
      MIN_AND_MAX = {
        min: 0,
        max: 40,
      };
      break;
    default:
      break;
  }
  return MIN_AND_MAX;
};

export const hairlossProgressIcons = [
  {
    icon: <Sensitivity />,
  },
  {
    icon: <Fraction />,
  },
  {
    icon: <Volume />,
  },
  {
    icon: <Density />,
  },
  {
    icon: <Follicle />,
  },
];

export const scalpResultItems = [
  {
    code: 'SCALP_HEALTH_SCORE',
    value: null,
    avg: null,
    img: null,
    min: 0,
    max: 100,
  },

  {
    code: 'WATER',
    value: null,
    avg: null,
    min: 0,
    max: 120,
    img: null,
    ref_code: 'AMBIENT_MOISTURE',
    ref_value: null,
    ref_avg: null,
    icon: <Moisture />,
  },
  {
    code: 'GAS',
    value: null,
    avg: null,
    min: 0,
    max: 500,
    img: null,
    ref_code: 'AMBIENT_GAS',
    ref_value: null,
    ref_avg: null,
    icon: <Smell />,
  },
  {
    code: 'TEMPERATURE',
    value: null,
    avg: null,
    min: 20,
    max: 40,
    img: null,
    ref_code: 'AMBIENT_TEMP',
    ref_value: null,
    ref_avg: null,
    icon: <Temperature />,
  },
  {
    code: 'DEAD_SKIN',
    value: null,
    avg: null,
    min: 0,
    max: 20,
    img: null,
    icon: <Keratin />,
  },
  {
    code: 'SENSITIVITY',
    value: null,
    avg: null,
    min: 0,
    max: 50,
    img: null,
    icon: <Sensitivity />,
  },
  {
    code: 'OIL',
    value: null,
    avg: null,
    min: 0,
    max: 5,
    img: null,
    icon: <Fraction />,
  },
  {
    code: 'HAIR_THICKNESS',
    value: null,
    avg: null,
    min: 0,
    max: 0.5,
    img: null,
    icon: <Follicle />,
  },
  {
    code: 'HAIR_QUANTITY',
    value: null,
    avg: null,
    min: 0,
    max: 50,
    img: null,
    icon: <Volume />,
  },
  {
    code: 'HAIR_FOLLICLE_DENSITY',
    value: null,
    avg: null,
    min: 0,
    max: 40,
    img: null,
    icon: <Density />,
  },
  {
    code: 'HAIR_PER_HAIR_FOLLICLE',
    value: null,
    avg: null,
    min: 0,
    max: 5.5,
    img: null,
    icon: <Follicle />,
  },
];

export let hairlossScore = 0;

export const arrangeResultItems = (result) => {
  // 탈모지수 초기화
  hairlossScore = 0;
  result.map((diagnosis, index) => {
    const idx = scalpResultOrder[diagnosis.item];
    if (idx >= 0) {
      scalpResultItems[idx].value = diagnosis.value.toFixed(2);
      scalpResultItems[idx].avg = diagnosis.average.toFixed(2);
      scalpResultItems[idx].img = diagnosis.image;
    } else {
      scalpResultItems[-1 * idx].ref_value = diagnosis.item_value.toFixed(2);
      scalpResultItems[-1 * idx].ref_avg = diagnosis.item_average.toFixed(2);
    }

    let min = 0,
      max = 0;
    // 탈모지수 계산
    const value = scalpResultItems[idx >= 0 ? idx : -1 * idx].value;

    switch (scalpResultItems[idx >= 0 ? idx : -1 * idx].code) {
      case 'HAIR_THICKNESS':
        min = 0.21;
        max = 0.25;

        if (0.21 <= value && value <= 0.25) {
          hairlossScore += ((max - value + 0.01) * 3) / (max - min);
        } else if (value < 0.21) hairlossScore += 4;
        break;
      case 'HAIR_QUANTITY':
        min = 20;
        max = 30;
        if (20 <= value && value <= 30) {
          hairlossScore += ((max - value + 1) * 3) / (max - min);
        } else if (value < 20) hairlossScore += 4;
        break;
      case 'HAIR_FOLLICLE_DENSITY':
        min = 13;
        max = 20;
        if (13 <= value && value <= 20) {
          hairlossScore += ((max - value + 1) * 3) / (max - min);
        } else if (value < 13) hairlossScore += 4;
        break;
      case 'HAIR_PER_HAIR_FOLLICLE':
        min = 1.2;
        max = 1.23;
        if (1.2 <= value && value <= 1.23) {
          hairlossScore += (max - value + 0.01) / (max - min);
        } else if (value < 1.2) hairlossScore += 2;
        break;
      default:
        break;
    }
    return null;
  });
};

export const calBarValueWidth = (code, barWidthRef, value, min, max, avg) => {
  let color = goodColor;
  switch (code) {
    case 'GENERAL':
      if (30 <= value && value <= avg) color = normalColor;
      else if (value < 30) color = badColor;
      break;
    case 'WATER':
      if (value < 50) color = normalColor; //normalColor is yellow
      else if (80 < value) color = badColor;
      break;
    case 'GAS':
      if (150 <= value && value <= 250) color = normalColor;
      else if (250 < value) color = badColor;
      break;
    case 'TEMPERATURE':
      if (35 <= value && value <= 36.5) color = normalColor;
      else if (36.5 < value) color = badColor;
      break;
    case 'DEAD_SKIN':
      if (3 <= value && value <= 6) color = normalColor;
      else if (6 < value) color = badColor;
      break;
    case 'SENSITIVITY':
      if (3 <= value && value <= 8) color = normalColor;
      else if (8 < value) color = badColor;
      break;
    case 'OIL':
      if (0.3 <= value && value <= 1) color = normalColor;
      else if (1 < value) color = badColor;
      break;
    case 'HAIR_THICKNESS':
      if (0.21 <= value && value <= 0.25) color = normalColor;
      else if (value < 0.21) color = badColor;
      break;
    case 'HAIR_QUANTITY':
      if (20 <= value && value <= 30) color = normalColor;
      else if (value < 20) color = badColor;
      break;
    case 'HAIR_FOLLICLE_DENSITY':
      if (13 <= value && value <= 20) color = normalColor;
      else if (value < 13) color = badColor;
      break;
    case 'HAIR_PER_HAIR_FOLLICLE':
      if (1.2 <= value && value <= 1.23) color = normalColor;
      else if (value < 1.2) color = badColor;
      break;
    default:
      break;
  }
  const bgWidth = barWidthRef?.current?.offsetWidth;
  if (bgWidth) {
    // console.log(`code : ${code}, value: ${value}, avg:${avg}`);
    // console.log('총 가로길이: ', bgWidth);
    let curPercentage = (value - min) / (max - min);
    // GAS ->  104/ 500  ---> 0.208
    // ㄱ레인지바 손대야함
    if (code === 'WATER' && curPercentage > 0) {
      curPercentage *= 1.17;
    } else if (code === 'GAS' && curPercentage > 0) {
      curPercentage *= 1.2;
    } else if (code === 'DEAD_SKIN' && curPercentage > 0) {
      curPercentage *= 2.39;
    } else if (code === 'SENSITIVITY' && curPercentage > 0) {
      curPercentage *= 3.3;
    } else if (code === 'OIL' && curPercentage > 0) {
      curPercentage *= 6.3;
    } else if (code === 'HAIR_THICKNESS' && curPercentage > 0) {
      curPercentage *= 1.08;
    } else if (code === 'HAIR_QUANTITY' && curPercentage > 0) {
      curPercentage *= 1.03;
    } else if (code === 'HAIR_FOLLICLE_DENSITY' && curPercentage > 0) {
      curPercentage *= 1.15;
    } else if (code === 'HAIR_PER_HAIR_FOLLICLE' && curPercentage > 0) {
      curPercentage *= 1.35;
    }
    // 0.2496;
    const valueWidth = parseInt(
      bgWidth *
        (curPercentage <= 0 ? 0.02 : curPercentage > 1 ? 1 : curPercentage),
    );
    return { width: valueWidth + 'px', background: color };
  } else return { width: '100px', background: color };
};

export const calBarAvgPosition = (barWidthRef, avg, min, max, isAvg) => {
  const bgWidth = barWidthRef?.current?.offsetWidth;
  if (bgWidth) {
    const curPercentage = (avg - min) / (max - min) - 0.5;
    let valueWidth = parseInt(
      bgWidth *
        (curPercentage <= -0.5 ? 0 : curPercentage > 0.5 ? 0.5 : curPercentage),
    );
    if (isAvg) {
      return { marginLeft: valueWidth + max - 10 + 'px' };
    }
    return { marginLeft: valueWidth + 'px' };
  } else return { marginLeft: '0px' };
};

export const getDiagnosisItems = (result) => {
  // result 매개변수는 GET_SCALP_RESULT dispatch했을 경우 받은 데이터
  let items = {
    GENERAL: 0,

    DEAD_SKIN: 0, // *** 현재 분석에 사용되는 value
    SENSITIVITY: 0, // *** 현재 분석에 사용되는 value
    OIL: 0, // *** 현재 분석에 사용되는 value
    WATER: 0, // *** 현재 분석에 사용되는 value

    TEMPERATURE: 0,
    HAIR_FOLLICLE_DENSITY: 0,
    HAIR_PER_HAIR_FOLLICLE: 0,
    HAIR_QUANTITY: 0,
    HAIR_THICKNESS: 0,
    AMBIENT_MOISTURE: 0,
    AMBIENT_GAS: 0,
    AMBIENT_TEMP: 0,
    OLD: 0,
    GAS: 0,
  };

  result.map((diagnosis) => {
    // console.log('diagnosis', diagnosis);
    const idx = scalpResultOrder[diagnosis.item];
    const code = scalpResultItems[idx > 0 ? idx : -1 * idx].code;
    const min = scalpResultItems[idx > 0 ? idx : -1 * idx].min;
    const max = scalpResultItems[idx > 0 ? idx : -1 * idx].max;
    const r = calBarValueWidth(code, null, diagnosis.value, min, max);
    if (
      diagnosis.item === 'WATER' ||
      diagnosis.item === 'SENSITIVITY' ||
      diagnosis.item === 'OIL' ||
      diagnosis.item === 'DEAD_SKIN'
    ) {
      switch (r.background) {
        case goodColor:
          items[diagnosis.item] = 1;
          break;
        case normalColor:
          items[diagnosis.item] = 2;
          break;
        case badColor:
          items[diagnosis.item] = 3;
          break;
        default:
          break;
      }
    }

    // if (item.name === 'WATER') items[item.name] = 2;
    // if (item.name === 'SENSITIVITY') items[item.name] = 3;
    // if (item.name === 'OIL') items[item.name] = 1;
    // if (item.name === 'DEAD_SKIN') items[item.name] = 1;
  });

  return JSON.stringify(items);
};
